import React, { useMemo } from 'react';

import { Tooltip } from '@mui/material';

import ProtectedData, { isProtectedData } from 'pages/components/ProtectedData';

import RedditIcon from './assets/reddit.svg';
import XIcon from './assets/twitter.svg';
import MentionCount from './components/MentionCount';
import useStyles from './styles';

interface Props {
    social: {
        twitter?: { counter: number };
        reddit?: { counter: number };
    };
    className?: string;
}

const Mentions: React.FC<Props> = ({ social, className }) => {
    const { classes, cx } = useStyles();

    const count = useMemo(
        () =>
            Object.values(social)
                .filter(Boolean)
                .map(({ counter }) => counter)
                .reduce((output, item) => {
                    if (isProtectedData(output)) {
                        return output;
                    }
                    if (isProtectedData(item)) {
                        return item;
                    }
                    return output + item;
                }, 0),
        [social]
    );

    return (
        <span className={cx(classes.container, className)}>
            <span>📰️</span>
            &nbsp;
            <ProtectedData data={count}>
                {({ isProtected, content }) =>
                    isProtected ? (
                        <span className={classes.primary}>{content}</span>
                    ) : (
                        <Tooltip
                            classes={{ tooltip: classes.tooltip }}
                            placement="bottom-start"
                            title={
                                <>
                                    {social.reddit?.counter ? (
                                        <MentionCount
                                            icon={RedditIcon}
                                            title={'Reddit'}
                                            count={social.reddit.counter}
                                        />
                                    ) : null}
                                    {social.twitter?.counter ? (
                                        <MentionCount icon={XIcon} title={'Twitter'} count={social.twitter.counter} />
                                    ) : null}
                                </>
                            }
                        >
                            <span className={cx(classes.primary, classes._underline)}>{content}</span>
                        </Tooltip>
                    )
                }
            </ProtectedData>
            &nbsp;
            <span className={classes.secondary}>{'Media mentions'}</span>
        </span>
    );
};

export default Mentions;
